'use client';
import { jsx } from 'react/jsx-runtime';
import cl from 'clsx/lite';
import { forwardRef } from 'react';

/**
 * `Badge` is a non-interactive component for displaying status with or without numbers.
 *
 * @example without children
 * <Badge count={5} maxCount={10} />
 *
 * @example with children
 * <Badge count={5} maxCount={10}>
 *   <Icon />
 * </Badge>
 */
const Badge = forwardRef(function Badge({ className, count, maxCount, variant = 'base', ...rest }, ref) {
    return (jsx("span", { className: cl('ds-badge', className), "data-count": count && maxCount && count > maxCount ? `${maxCount}+` : count, "data-variant": variant, ref: ref, ...rest }));
});

export { Badge };
